<template>
	<div class="hitchFeedback mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">用户故障反馈</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disStart">
				<span class="title">故障派单</span>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
								<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
								<!-- <el-select clearable v-model="searchObj.communityId" allow-create filterable remote
									reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod"
									@change="changeSelect">
									<el-option v-for="item in restaurants" :key="item.communityId"
										:label="item.communityName" :value="item.communityId">
									</el-option>
								</el-select> -->
						</div>
						<!-- <div class="myinputBox">
							<div class="myinputBox">
								<el-select clearable v-model="searchObj.communitySiteName" slot="prepend"
									placeholder="请选择充电站">
									<el-option v-for="(item,inx) in stationList" :key="inx"
										:label="item.communitySiteName" :value="item.communitySiteName"></el-option>
								</el-select>
							</div>
						</div> -->
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityEquipmentNo" placeholder="请输入设备编号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.faultType" slot="prepend" placeholder="请选择故障类型">
								<el-option v-for="(item,inx) in faultTypeList" :key="inx"
									:label="item.paramConfigItemName" :value="item.paramConfigItemId"></el-option>
							</el-select>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
							<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
								value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column prop="createTime" label="反馈时间" width="150">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentName" label="设备名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="communitySiteName" label="所属站点">
							</el-table-column> -->
							<el-table-column show-overflow-tooltip prop="faultType" label="故障类型">
								<template slot-scope="scope">
									<span>{{getName(scope.row.faultType,faultTypeList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="faultDesc" label="故障说明">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userName" label="反馈用户"></el-table-column>
							<el-table-column show-overflow-tooltip prop="contactName" label="联系人"></el-table-column>
							<el-table-column show-overflow-tooltip prop="contactPhone" label="联系方式"></el-table-column>
							<el-table-column show-overflow-tooltip label="操作">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row)">详情</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="故障派单信息" center class="mydialog" :visible.sync="dialogVisible" width="60%">
			<div class="dialogBox3">
				<div class="titleBox">故障设备信息(设备编号：{{diaObj.communityEquipmentNo}})</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>设备名称：{{diaObj.communityEquipmentName}}</span>
						<span>社区名称：{{diaObj.communityName}}</span>
						<span>充电桩名称：{{diaObj.communitySiteName}}</span>
					</div>
					<div class="itemBox ">
						<span>省市区具体地址：{{diaObj.provinceName||""}}{{diaObj.cityName||""}}{{diaObj.areaName||""}}</span>
					</div>
					<div class="itemBox ">
						<span>故障说明：{{diaObj.faultDesc}}</span>
					</div>
					<div class="itemBox itemBox2 ">
						<span>现场图片：</span>
						<div class="imgBox disStart">
							<el-image style="width: 100px; height: 100px" v-for="(item,inx) in diaObj.imgList"
								:key="inx" :src="item" :preview-src-list="diaObj.imgList"> </el-image>
						</div>
					</div>
					<div class="itemBox itemBox1 disStart">
						<span>故障时间：{{diaObj.createTime}}</span>
						<span>故障类型：{{getName(diaObj.faultType,faultTypeList)}}</span>
					</div>
				</div>
				<div class="titleBox">用户反馈信息</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>反馈用户：{{diaObj.userName}}</span>
						<span>联系人：{{diaObj.contactName}}</span>
						<span>联系方式：{{diaObj.contactPhone}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	export default {
		name: "hitchFeedback",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				diaObj: {},
				dialogVisible: false,
				tableData: [],
				communityList: [],
				stationList: [],
				faultTypeList: [],
				loading: false,
				searchObj: {
					faultType: "", //社区编号
					communityName: "",
					communitySiteName: "",
					startTime: "",
					endTime: "",
					searchData: [],
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				restaurants: [],
				options: []
			}
		},
		mounted() {
			this.selectParamConfigByCode()
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {

				this.getData()
			})
		},
		methods: {
			selectParamConfigByCode() {
				this.$api.selectParamConfigByCode({
					"paramCode": 1001,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "faultTypeList", res.obj.paramConfigItemList)
					}
				})
			},
			itemClick(item) {
				let arr = item.pictureUrl.split(",")
				this.$set(this, "diaObj", item)
				this.$set(this.diaObj, "imgList", [])
				for (let k of arr) {
					this.diaObj.imgList.push(this.$basImgUrl + k)
				}
				this.dialogVisible = true
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n, k) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}

			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.paramConfigItemId
				}) || {}
				return obj.paramConfigItemName || ""
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listCommunityEquipmentFaultReport(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo,"pagenum",val)
				this.$set(this.searchObj,"pageNo",val)
				this.getData({})
			},

		}
	}
</script>

<style lang="scss" scoped>
	@import "./hitchFeedback.scss";
</style>